// Casticart AI 自己利用メーターの純ロジック（Web共通）。
// チャット見出しメーター（ServiceAiUsageMeter）とグローバルヘッダーのアバターリング（HeaderAiUsage）で共有する。

export const usageRingColor = (usedPct) => (usedPct >= 90 ? '#d64545' : usedPct >= 70 ? '#e0902a' : '#5a9e2b');

// 1期間ぶんの利用状況を、上限に対する使用率へ正規化する。
// 上限（token/円のいずれか）が無ければ unlimited=true（レインボー＋トークン実数表示）。
const periodMeter = (aggregate, tokenLimit, yenLimit) => {
  const tokens = Number(aggregate?.totalTokens || 0);
  const cost = Number(aggregate?.estimatedCostJpy || 0);
  const ratios = [];
  if (Number(tokenLimit) > 0) ratios.push(tokens / Number(tokenLimit));
  if (Number(yenLimit) > 0) ratios.push(cost / Number(yenLimit));
  if (!ratios.length) return { unlimited: true, usedPct: 0, remainingPct: 100, tokens };
  const usedRatio = Math.max(...ratios);
  const usedPct = Math.min(100, Math.max(0, Math.round(usedRatio * 100)));
  return { unlimited: false, usedPct, remainingPct: Math.max(0, 100 - usedPct), tokens };
};

// usageサマリ→今日/今月のメーター表現。
export function computeServiceAiUsageMeter(usage) {
  const policy = usage?.effectivePolicy && usage.effectivePolicy.enabled !== false
    ? usage.effectivePolicy
    : null;
  return {
    today: periodMeter(usage?.today, policy?.dailyTokenLimit, policy?.dailyBudgetJpy),
    month: periodMeter(usage?.month, policy?.monthlyTokenLimit, policy?.monthlyBudgetJpy),
  };
}
